import _classCallCheck from "/Users/eriksuen/Documents/digigear/projects/dgg-websites/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/Users/eriksuen/Documents/digigear/projects/dgg-websites/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _inherits from "/Users/eriksuen/Documents/digigear/projects/dgg-websites/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/Users/eriksuen/Documents/digigear/projects/dgg-websites/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/Users/eriksuen/Documents/digigear/projects/dgg-websites/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import EventEmitter from 'eventemitter3';
export { EventEmitter };
/**
 * A wallet's readiness describes a series of states that the wallet can be in,
 * depending on what kind of wallet it is. An installable wallet (eg. a browser
 * extension like Phantom) might be `Installed` if we've found the Phantom API
 * in the global scope, or `NotDetected` otherwise. A loadable, zero-install
 * runtime (eg. Torus Wallet) might simply signal that it's `Loadable`. Use this
 * metadata to personalize the wallet list for each user (eg. to show their
 * installed wallets first).
 */

export var WalletReadyState;

(function (WalletReadyState) {
  /**
   * User-installable wallets can typically be detected by scanning for an API
   * that they've injected into the global context. If such an API is present,
   * we consider the wallet to have been installed.
   */
  WalletReadyState["Installed"] = "Installed";
  WalletReadyState["NotDetected"] = "NotDetected";
  /**
   * Loadable wallets are always available to you. Since you can load them at
   * any time, it's meaningless to say that they have been detected.
   */

  WalletReadyState["Loadable"] = "Loadable";
  /**
   * If a wallet is not supported on a given platform (eg. server-rendering, or
   * mobile) then it will stay in the `Unsupported` state.
   */

  WalletReadyState["Unsupported"] = "Unsupported";
})(WalletReadyState || (WalletReadyState = {}));

export var BaseWalletAdapter = /*#__PURE__*/function (_EventEmitter) {
  _inherits(BaseWalletAdapter, _EventEmitter);

  var _super = _createSuper(BaseWalletAdapter);

  function BaseWalletAdapter() {
    _classCallCheck(this, BaseWalletAdapter);

    return _super.apply(this, arguments);
  }

  _createClass(BaseWalletAdapter, [{
    key: "connected",
    get: function get() {
      return !!this.publicKey;
    }
  }]);

  return BaseWalletAdapter;
}(EventEmitter);
export function scopePollingDetectionStrategy(detect) {
  // Early return when server-side rendering
  if (typeof window === 'undefined' || typeof document === 'undefined') return;
  var disposers = [];

  function detectAndDispose() {
    var detected = detect();

    if (detected) {
      var _iterator = _createForOfIteratorHelper(disposers),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var dispose = _step.value;
          dispose();
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }
  } // Strategy #1: Try detecting every second.


  var interval = // TODO: #334 Replace with idle callback strategy.
  setInterval(detectAndDispose, 1000);
  disposers.push(function () {
    return clearInterval(interval);
  }); // Strategy #2: Detect as soon as the DOM becomes 'ready'/'interactive'.

  if ( // Implies that `DOMContentLoaded` has not yet fired.
  document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', detectAndDispose, {
      once: true
    });
    disposers.push(function () {
      return document.removeEventListener('DOMContentLoaded', detectAndDispose);
    });
  } // Strategy #3: Detect after the `window` has fully loaded.


  if ( // If the `complete` state has been reached, we're too late.
  document.readyState !== 'complete') {
    window.addEventListener('load', detectAndDispose, {
      once: true
    });
    disposers.push(function () {
      return window.removeEventListener('load', detectAndDispose);
    });
  } // Strategy #4: Detect synchronously, now.


  detectAndDispose();
}